
import * as THREE from "three"



export default class Tool {

    //#selection

    constructor() {

        /**
         *
         * @type Mapping
         */
        this.mapping = null

        this.app = null

        this.data = {
            selection: 'dot',
            selection_dot_multiple: false,
            mapping: {
                active: 0
            },
            display: {
                grid:   false, //( typeof(app_parameters.scene.model.grid.display) !== 'undefined' ) ? app_parameters.scene.model.grid.display : true,
                dot:    false //( typeof(app_parameters.scene.model.dot.display) !== 'undefined' ) ? app_parameters.scene.model.dot.display : true
            }
        }

        return this

    }

    isDotMultiple() {

        return this.data.selection_dot_multiple

    }

    setDotMultiple( boolean ) {

        this.data.selection_dot_multiple = boolean

        //if (boolean) {

            //this.app.layout.select.unselect()

        //}

        return this

    }

    displayGrid( status ) {

        this.data.display.grid = status

    }

    displayDot( status ) {

        this.data.display.dot = status

    }

    displayDotGrid( status ) {

        this.displayDot( status )
        this.displayGrid( status )

    }

    isDisplayDot() {

        return this.data.display.dot

    }

    isDisplayGrid() {

        return this.data.display.grid

    }

    isDisplayDotGrid() {

        return this.data.display.grid && this.data.display.dot

    }

    setMapping(mapping) {

        this.mapping = mapping

        return this

    }

    setApp(app) {

        this.app = app

        return this

    }

    getMappingActive() {

        return this.data.mapping.active

    }

    setMappingActive(index) {

        console.log('tool.setMappingActive( ' + index + ' )')

        if ( index <= this.mapping.count() ) {

            //if ( this.mapping.select(index) )   // false or object

                this.data.mapping.active = index    // update

            this.app.grid = this.mapping.getGrid( this.getMappingActive() )

            this.app.sceneOverlay = new THREE.Scene()

            //this.app.sceneOverlay.add( this.app.sceneContainer.getSceneOverlay( this.getMappingActive() ).gridline  )

            console.log( this.getMappingActive() )

            let a = this.app.sceneContainer.getSceneOverlay( this.getMappingActive() )

            if ( typeof a !== "undefined" ) {

                let b = a.dots

                if ( typeof b !== "undefined" ) {

                    this.app.sceneOverlay.add(b)

                } else {

                    console.log('err 2')

                }

                //console.log(index)
                //console.log(this.app.grid)

                // action

            } else {

                    console.log('err 1')

            }



                return this

        }

        return false


    }

    setDot() {

        this.data.selection = 'dot'

        return this

    }

    setLineU() {

        this.data.selection = 'line_u'

        return this

    }

    setLineV() {

        this.data.selection = 'line_v'

        return this

    }

    isDot() {

        if (this.data.selection == 'dot')
            return true

        return false

    }

    isLineU() {

        if (this.data.selection == 'line_u')
            return true

        return false

    }

    isLineV() {

        if (this.data.selection == 'line_v')
            return true

        return false

    }

}